jQuery(function (jQuery) {
  success_story__slider();
  tm_slider();
  testimonials_owl_slider();
  testimonial_readmore();
  testimonial__video();
  smooth_scroll();
  onscroll_show_icon_testimonial();
  faqs_accordion();
  portfolio__slider();
  banner_slider() ;
  jQuery(document).ready(function () {
    jQuery(".contact-form-popup").fancybox({
      openEffect: "none",
      closeEffect: "none",
    });

    jQuery("#contact_form_pop p:has(> input.submit-contact-form)").addClass(
      "submit-cta"
    );

    jQuery("body").on("mousemove", function () {
      if (getCookie("bodyfont") == 1) {
        jQuery("body").removeClass("remove_font");
      }
    });
  });
});

jQuery(window).load(function () {
  jQuery("body").addClass("header_show");
});

function success_story__slider() {
  var owl = jQuery(".success_story_slider");
  owl.owlCarousel({
    items: 1,
    margin: 30,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    smartSpeed: 2500,
    paginationSpeed: 1500,
    autoplayTimeout: 4000,
    responsive: {
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });
}

function portfolio__slider() {
  var owl = jQuery(".hire-talent-wrapper");
  owl.owlCarousel({
    items: 1,
    margin: 30,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    smartSpeed: 2500,
    paginationSpeed: 1500,
    autoplayTimeout: 4000,
    responsive: {
      768: {
        items: 2,
      },
      992: {
        autoplay: false,
      },
      1024: {
        items: 3,
        autoplay: false,
      },
    },
  });
}

// tm-slider js start
function tm_slider() {
  jQuery(".tm-slider").owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 2200,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    paginationSpeed: 1500,
    animateOut: "fadeOut",
    responsive: {
      768: {
        autoplay: true,
      },
    },
  });
}

function testimonials_owl_slider() {
  jQuery(".testimonial_owl_slider").owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    dots: false,
    items: 1,
    animateOut: "fadeOut",
    touchDrag: false,
    mouseDrag: false,
  });
}

function testimonial_readmore() {
  var showChar = 200; // How many characters are shown by default

  var moretext = "Read more";
  var lesstext = "Read less";

  jQuery(".testimonial_section_readmore .more").each(function () {
    var content = jQuery(this).html().trim();

    if (content.length > showChar) {
      var c = content.substr(0, showChar);
      var h = content.substr(showChar, content.length - showChar);

      var html =
        c +
        '<span class="dots">...</span><span class="morecontent">' +
        h +
        "</span>";

      var linkhtml =
        '<div class="link-wrap"><a href="#" class="morelink link_arrow" title="' +
        moretext +
        '">' +
        moretext +
        "</a></div>";

      jQuery(this).html(html);

      jQuery(linkhtml).insertAfter(this);
    }
  });

  jQuery(".testimonial_section_readmore .morelink").click(function () {
    if (jQuery(this).hasClass("less")) {
      jQuery(this).removeClass("less");
      jQuery(this).html(moretext);
      jQuery(this).attr("title", moretext);
    } else {
      jQuery(this).addClass("less");
      jQuery(this).html(lesstext);
      jQuery(this).attr("title", lesstext);
    }

    jQuery(this).parent().parent().find("span").toggle();
    return false;
  });
}

// Match Your Ingenuity video popup js start here
function testimonial__video() {
  jQuery(
    ".testimonial_section .testimonial_single,.video_testi_section .testimonial_single"
  ).fancybox({
    afterShow: function () {
      // After the show-slide-animation has ended - play the video
      this.content.find("video").trigger("play");
      // Trigger fancybox.close() once the video has ended
      this.content.find("video").on("ended", function () {
        $.fancybox.close();
      });
    },
  });
}

// FAQs accordion js start here
function faqs_accordion() {
  
  jQuery("#faq .accordian > div,#faq .accordian .accordion-item")
  .slice(0, 8)
  .show();
  jQuery("#loadmore").on("click", function (e) {
    e.preventDefault();
    jQuery(
      "#faq .accordian > div:hidden,#faq .accordian .accordion-item:hidden"
    )
      .slice(0, 8)
      .slideDown();
    if (
      jQuery(
        "#faq .accordian > div:hidden,#faq .accordian .accordion-item:hidden"
      ).length == 0
    ) {
      jQuery("#loadmore").fadeOut("slow");
    }
  });

  jQuery(".faq_section .accordion .accordion-item").slice(0, 8).show();
  jQuery("#loadmore").on("click", function (e) {
    e.preventDefault();
    jQuery(".faq_section .accordion .accordion-item:hidden")
      .slice(0, 8)
      .slideDown();
    if (jQuery(".faq_section .accordion .accordion-item:hidden").length == 0) {
      jQuery("#loadmore").fadeOut("slow");
    }
  });
  
  jQuery.fn.accordion = function () {
    const trigger = jQuery(this).find(".accordion-one");
    const collapse = jQuery(this).find(".collapse-one");

    jQuery(trigger).first().addClass("accordion-open");
    jQuery(collapse).first().show();

    jQuery(trigger).each(function () {
      jQuery(this).on("click", function () {
        jQuery(this).siblings(".collapse-one").slideToggle();
        jQuery(this).toggleClass("accordion-open");
        jQuery(this).parent().toggleClass("show_item");
        jQuery(this)
          .parent()
          .siblings(".accordion-item")
          .find(".accordion-one")
          .removeClass("accordion-open");
        jQuery(this)
          .parent()
          .siblings(".accordion-item")
          .find(".collapse-one")
          .slideUp();
        jQuery(this)
          .parent()
          .siblings(".accordion-item")
          .removeClass("show_item");
      });
    });
  };
  jQuery(".accordion").accordion();
}

// smooth scroll js
function smooth_scroll() {
  if (
    !jQuery("body").hasClass("template-industry-page") &&
    !jQuery("body").hasClass("partner-page-template")
  ) {
    jQuery('a[href*="#"].btn').on("click", function (e) {
      e.preventDefault();

      var header_h = jQuery(".biztech-header").outerHeight();
      if (jQuery("header").hasClass("header_show")) {
        jQuery("html, body").animate(
          {
            scrollTop:
              jQuery(jQuery(this).attr("href")).offset().top - header_h,
          },
          400
        );
      } else {
        jQuery("html, body").animate(
          {
            scrollTop:
              jQuery(jQuery(this).attr("href")).offset().top - header_h - 20,
          },
          400
        );
      }
      if (
        jQuery("body").hasClass("template-salesforce-development") ||
        jQuery("body").hasClass("template-salesforce-page") ||
        jQuery("body").hasClass("template-services-development")
      ) {
        jQuery("#schedule-interview .fname").focus();
      }
    });
  }
}

// onscroll show icon in testimonial right side js
function onscroll_show_icon_testimonial() {
  jQuery(window).on("scroll", function () {
    jQuery(".scroll_class").each(function () {
      if (isScrolledIntoView(jQuery(this))) {
        jQuery(this).addClass("active");
      }
    });
  });

  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function banner_slider() {
  jQuery(".template-industry .success-slider").owlCarousel({
    items: 2,
    loop: false,
    margin: 40,
    nav: false,
    dots: false,
    autoplay: false,
    smartSpeed: 2200,
    autoplayTimeout: 3200,
    autoplayHoverPause: true,
    responsive: {
      768: {
        items: 4,
        margin: 40,
        nav: true,
      },
      1024: {
        items: 5,
        loop: true,
        autoplay: true,
        margin: 60,
      },
      1200: {
        items: 6,
        nav: false,
        autoplay: false,
      },
      1340: {
        items: 6,
        autoplay: false,
        loop: true,
      },
    },
  });
}


// WEBPACK FOOTER //
// ./scripts/common/script.js